import TagManager from "@sooro-io/react-gtm-module";
import { digestMessage } from "../../utils/digestMessage.ts";

export const pushGTMUserData = async ({
  email = null,
  firstName = null,
  lastName = null,
  jobTitle = null,
  phoneNumber = null,
}: {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  jobTitle?: string | null;
  phoneNumber?: string | null;
}) => {
  TagManager.dataLayer({
    dataLayer: {
      user_data: {
        // Enhanced conversion - standard fields
        ...(email && {
          email,
          sha256_email_address: await digestMessage(email),
        }),
        ...(phoneNumber &&
          isPhoneNumberE164(phoneNumber) && {
            phone_number: phoneNumber,
            sha256_phone_number: await digestMessage(phoneNumber),
          }),
        ...(firstName &&
          lastName && {
            address: {
              first_name: firstName,
              sha256_first_name: await digestMessage(firstName),
              last_name: lastName,
              sha256_last_name: await digestMessage(lastName),
            },
          }),
        ...(jobTitle && {
          jobTitle,
        }),
      },
    },
  });
};

const isPhoneNumberE164 = (phoneNumber: string): boolean => {
  const regEx = /^\+[1-9]\d{10,14}$/u;
  return regEx.test(phoneNumber);
};
